export default {
  '请求': {
    '加载中': 'Cargando',
    '请求失败': 'Error en la solicitud',
    '登录已过期': 'Sesión expirada',
    '网络连接失败': 'Error de conexión de red',
    '请重新登录': 'Inicie sesión de nuevo',
    '没有权限访问': 'Acceso denegado',
    '请求的资源不存在': 'Recurso no encontrado',
    '服务器错误': 'Error del servidor',
    '网络错误': 'Error de red',
    '刷新成功': 'Actualizado',
    '获取中': 'Cargando......',
    '账号下线': 'Cuenta desconectada',
    '功能已禁用': 'Función desactivada',
  },
  '导航': {
    '首页': 'Inicio',
    '选妃': 'Elegir',
    '认证': 'Verificar',
    '影院': 'Vídeo',
    '个人': 'Mío',
  },
  '首页': {
    '注册': 'Registrarse',
    '影片': 'Vídeo',
    '女团': 'Chicas',
    '热门城市': 'Ciudades populares:',
    '经理预订': 'Reserva del manager',
    '看更多': 'Más',
    '身份验证': 'Verificado',
    '身高': 'Altura',
    '胸围': 'Busto',
    '服务城市': 'Ciudad:',
  },
  '女团': {
    '女团': 'Chicas',
    '选妃': 'Elegir',
    '身份验证': 'Verificado',
    '身高': 'Altura',
    '胸围': 'Busto',
    '服务城市': 'Ciudad:',
    '注册': 'Registrarse',
    '请联系顾问或接待员': 'Contacte con un asesor',
  },
  '登录': {
    '登录会员视窗': 'Inicio de sesión de miembro',
    '请输入用户名': 'Usuario',
    '请输入密码': 'Contraseña',
    '登录': 'Iniciar sesión',
    '没有账号马上注册': '¿Sin cuenta? Regístrese',
    '登录成功': 'Inicio de sesión correcto',
    '登录注册': 'Iniciar sesión / Registrarse',
    '登录可享受更多服务': '¡Inicie sesión para más servicios!',
  },
  '注册': {
    '注册': 'Registrarse',
    '登录': 'Iniciar sesión',
    '请输入用户名': 'Usuario',
    '用户名规则': '6-20 letras/números',
    '请输入密码': 'Contraseña',
    '密码规则': '6-16 letras y números',
    '请输入验证码': 'Captcha',
    '验证码规则': 'Introduzca el captcha de 4 dígitos',
    '请输入邀请码': 'Código de invitación',
    '邀请码规则': 'Introduzca el código de agente',
    '同意协议': 'Tengo 18+ y acepto los Términos',
    '立即注册': 'Registrarse ahora',
    '注册中': 'Registrando...',
    '已有账号马上登录': '¿Ya tiene cuenta? Iniciar sesión',
    '注册成功': '¡Registrado!',
    '注册失败': 'Error de registro: ',
    '验证码错误': 'Captcha inválido',
    '请同意注册条款': 'Acepte los términos',
    '用户名已存在': 'El usuario ya existe',
    '邀请码无效': 'Código de invitación inválido',
  },
  '抢单': {
    '今日收益': 'Ingresos de hoy',
    '余额': 'Saldo',
    '订单': 'Pedidos',
    '开始抢单': 'Tomar pedido',
    '当前等级': 'Nivel:',
    '提现': 'Retirar',
    '在线客服': 'Soporte',
    '充值': 'Recargar',
    '幸运任务': 'Tarea de la suerte',
    '幸运订单': 'Pedido de la suerte',
    '幸运订单提示': '¡Felicidades! Pedido con alta comisión',
    '恭喜获得幸运订单': '¡Pedido de la suerte!',
    '提交订单': 'Enviar pedido',
    '未完成订单提示': 'Tiene un pedido sin pagar. Pague primero.',
    '正在获取订单': 'Cargando pedido...',
    '抢单时间': 'Hora de toma:',
    '订单号': 'N.º de pedido',
    '订单总额': 'Total',
    '佣金': 'Comisión',
    '商品单价': 'Precio',
    '预计收入': 'Ganancias est.',
    '确认支付': 'Pagar ahora',
    '确认付款': 'Confirmar pago',
    '支付处理中': 'Procesando...',
    '取消': 'Cancelar',
    '去查看': 'Ver',
    '暂无可用订单': 'No hay pedidos disponibles',
    '正在加载用户信息': 'Cargando info de usuario...',
    '今日抢单已达上限': 'Límite diario alcanzado',
    '余额不足无法获取订单': 'Saldo insuficiente',
    '获取订单失败': 'Error al obtener el pedido',
    '支付成功': 'Pago correcto',
    '支付失败': 'Pago fallido',
    '支付失败请重试': 'Pago fallido, inténtelo de nuevo',
    '请完成任务单后进入': 'Complete las tareas primero',
    '请设置收款卡': 'Vincule una dirección de cobro',,
    '当前余额': 'Saldo actual',
    '还需缴纳': 'Importe a pagar',
  },
  '我的': {
    '我的页面': 'Mi página',
    '钻石': 'Diamante',
    '信誉分': 'Crédito',
    '开通专属会员': 'Abrir VIP',
    '开启一次日期不限': 'Desbloqueo único, sin límite de fecha',
    '提现': 'Retirar',
    '历史订单': 'Historial de pedidos',
    '充值记录': 'Historial de recargas',
    '提现记录': 'Historial de retiros',
    '添加钱包地址': 'Añadir dirección de billetera',
    '邀请码': 'Código de invitación:',
    '余额': 'Saldo',
    '退出登陆': 'Cerrar sesión',
  },
  '会员': {
    '会员等级': 'Membresía:',
    '普通等级': 'Normal',
    '当前等级': 'Actual',
    '立即开通': 'Activar',
    '免费说明': '(Vídeos gratis) (Emparejamiento gratis)',
    '所需投资': 'Inversión requerida',
    '佣金': 'Comisión',
    '订单': 'Pedidos',
    '加入': 'Unirse >>',
  },
  '充值': {
    '充值': 'Recargar',
    '当前余额': 'Saldo',
    '余额': 'Saldo: ',
    '个': '',
    '充值金额': 'Importe',
    '请输入充值金额': 'Introduzca el importe',
    '快速选择金额': 'Importe rápido',
    '确认': 'Confirmar',
    '提示': 'Consejo',
    '金额错误': 'Importe inválido',
    '立即充值': 'Recargar ahora',
    '提交成功': 'Enviado, pendiente de revisión',
  },
  '提现': {
    '提现': 'Retirar',
    '兑换积分': 'Retirar puntos',
    '最大提款金额': 'Importe máx.',
    '资金密码': 'Contraseña de fondos',
    '余额': 'Saldo: ',
    '个': '',
    '钱包地址': 'Dirección de billetera: ',
    '请选择提款地址': 'Seleccione la dirección de retiro',
    '暂无绑定地址': 'Aún no hay dirección vinculada',
    '提交': 'Enviar',
    '通知': 'Aviso:',
    '单笔最大提现': '1. Máx. por retiro: ',
    '单笔最低提现': '2. Mín. por retiro: ',
    '检查姓名账号': '3. Compruebe su nombre y cuenta',
    '注意提款费用': '4. Atención a las comisiones de retiro',
    '请填写正确的金额': 'Introduzca un importe válido',
    '当前余额': 'Saldo',
    '提现金额': 'Importe',
    '请输入提现数量': 'Introduzca el importe',
    '立即提现': 'Retirar ahora',
    '交易密码': 'Contraseña de pago',
    '请输入交易密码': 'Introduzca la contraseña de pago',
    '请先设置提现密码': 'Configure primero la contraseña de retiro',
  },
  '绑卡': {
    '添加钱包地址': 'Añadir dirección de billetera',
    '钱包地址信息': 'Datos de la billetera',
    '请输入支付卡信息': 'Introduzca su dirección de billetera',
    '加密货币类型': 'Tipo de cripto',
    '请选择加密货币类型': 'Seleccione el tipo de cripto',
    '钱包地址': 'Dirección de monedero',
    '请输入钱包地址': 'Introduzca la dirección del monedero',
    '绑卡说明': 'Estimado usuario, para la seguridad de sus fondos, vincule su nombre real y establezca una contraseña de retiro. El nombre debe coincidir con la cuenta.',
    '确定绑卡': 'Confirmar vinculación',
    '绑卡提示': 'Consejo: vincule un banco importante. Contacte con soporte para modificar.',
    '请先设置姓名': '¡Configure su nombre antes de vincular!',
    '已绑定不可修改': 'Dirección ya vinculada. Contacte con soporte para cambiarla.',
  },
  '订单历史': {
    '订单历史': 'Historial de pedidos',
    '数据为空': 'Sin datos',
    '订单号': 'N.º de pedido: ',
    '已完成': 'Completado',
    '处理中': 'En proceso',
    '完成订单': 'Completar pedido',
    '订单金额': 'Importe: ',
    '佣金': 'Comisión: ',
    '创建时间': 'Creado: ',
    '上一页': 'Ant.',
    '下一页': 'Sig.',
    '获取失败': 'Error al cargar el historial',
    '获取失败重试': 'Error al cargar, inténtelo de nuevo',
    '未知': 'Desconocido',
    '完成成功': '¡Pedido completado!',
    '完成失败': 'Error al completar: ',
    '完成失败重试': 'Error al completar, inténtelo de nuevo',
    '请输入支付密码': 'Introduce la contraseña de pago',
    '请先设置支付密码': 'Configure primero la contraseña de pago',
  },
  '入金记录': {
    '标题': 'Historial de recargas',
    '数据为空': 'Sin datos',
    '认证结果': 'Resultado',
    '下单积分': 'Puntos: ',
    '下单时间': 'Pedido: ',
    '结算时间': 'Liquidado: ',
    '待审核': 'Pendiente',
    '已通过': 'Aprobado',
    '已拒绝': 'Rechazado',
    '暂无数据': 'Sin datos',
  },
  '提现记录': {
    '标题': 'Historial de retiros',
    '数据为空': 'Sin datos',
    '待审核': 'Pendiente',
    '审核成功': 'Aprobado',
    '审核退回': 'Rechazado',
    '未知状态': 'Desconocido',
    '金额': 'Importe: ',
    '说明': 'Nota: ',
    '提交时间': 'Enviado: ',
    '审核时间': 'Revisado: ',
    '已通过': 'Aprobado',
    '已拒绝': 'Rechazado',
    '暂无数据': 'Sin datos',
  },
  '资料': {
    '基本信息': 'Perfil',
    '头像': 'Avatar',
    '姓名': 'Nombre',
    '未设置': 'No definido',
    '性别': 'Sexo',
    '男': 'Hombre',
    '女': 'Mujer',
    '未知': 'Desconocido',
    '设定': 'Ajustes',
    '账号信息': 'Cuenta',
    '更改登录密码': 'Cambiar contraseña de acceso',
    '设定支付密码': 'Establecer contraseña de pago',
    '退出登录': 'Cerrar sesión',
    '设置': 'Ajustes',
    '登录密码': 'Contraseña de acceso',
    '资金密码': 'Contraseña de fondos',
    '提现密码已设置': 'Contraseña de retiro establecida. Contacte con soporte para cambiarla.',
    '已设置': 'Establecido',
    '修改真实姓名': 'Editar nombre real',
    '请输入真实姓名': 'Introduzca el nombre real',
    '真实姓名说明': 'El nombre real debe coincidir con los datos de la billetera',
    '提交': 'Enviar',
    '请勿重复设置': '¡Ya está definido!',
    '修改登录密码': 'Cambiar contraseña de acceso',
    '设置资金密码': 'Establecer contraseña de fondos',
    '保存': 'Guardar',
    '旧密码': 'Contraseña anterior',
    '请输入旧密码': 'Introduzca la contraseña anterior',
    '新密码': 'Nueva contraseña',
    '请输入新密码': 'Introduzca la nueva contraseña',
    '确认密码': 'Confirmar contraseña',
    '请再次输入新密码': 'Introduzca de nuevo la nueva contraseña',
    '请填写完整': '¡Rellene todos los campos!',
    '两次密码不一致': 'Las contraseñas no coinciden',
    '性别修改': 'Editar sexo',
    '个人报表': 'Informe personal',
    '任务金额积分': 'Importe de tareas (puntos)',
    '盈利公式': 'Beneficio = Ganancia − Importe de tareas',
    '任务金额': 'Importe de tareas',
    '充值金额': 'Recarga',
    '金额': 'Importe',
    '中奖金额': 'Importe ganado',
    '个人情报': 'Perfil',
    '身高': 'Altura:',
    '胸围': 'Busto:',
    '收费区间': 'Rango de precios:',
    '系统公告': 'Anuncios',
  },
  '客服': {
    '联系客服': 'Contactar soporte',
    '在线客服': 'Soporte en línea',
    '暂无客服': 'No hay soporte disponible',
    '联系': 'Contactar',
    '服务时间': 'A su servicio 24/7',
  },
  '影院': {
    '影院': 'Cine',
    '全部': 'Todo',
    '最高分': 'Mejor valorados',
    '播放': 'Reproducciones: ',
    '次播放': ' reproducciones',
    '热门推荐': 'Popular',
    '播放次数': 'Reproducciones:',
    '请充值后观看': 'Recargue para ver',
  },
  '语言切换器': {
    '切换语言': 'Idioma',
    '语言': 'Idioma',
  },
}
